var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JOURNAL-07A",
    transform: "translate(-610.000000, -444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(610.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#279CF7",
    strokeWidth: 2,
    fill: "#E9F5FE",
    cx: 42.5,
    cy: 42.5,
    r: 41.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3635254,55.3037109 C44.3635254,52.2275391 44.7114258,49.9020996 45.4072266,48.3273926 C46.1030273,46.7526855 47.6228027,44.8300781 49.9665527,42.5595703 C53.189209,39.4345703 55.331543,37.0664062 56.3935547,35.4550781 C57.4555664,33.84375 57.9865723,31.7441406 57.9865723,29.15625 C57.9865723,24.8837891 56.5400391,21.3742676 53.6469727,18.6276855 C50.7539062,15.8811035 46.9025879,14.5078125 42.0930176,14.5078125 C36.8928223,14.5078125 32.8034668,16.1130371 29.8249512,19.3234863 C26.8464355,22.5339355 25.3571777,26.7758789 25.3571777,32.0493164 L25.3571777,32.0493164 L31.8757324,32.0493164 C31.9978027,28.8754883 32.498291,26.4462891 33.3771973,24.7617188 C34.9396973,21.734375 37.7595215,20.2207031 41.8366699,20.2207031 C45.1325684,20.2207031 47.4946289,21.0996094 48.9228516,22.8574219 C50.3510742,24.6152344 51.0651855,26.6904297 51.0651855,29.0830078 C51.0651855,30.7919922 50.5769043,32.4399414 49.6003418,34.0268555 C49.0632324,34.9301758 48.3552246,35.796875 47.4763184,36.6269531 L47.4763184,36.6269531 L44.5466309,39.5200195 C41.7390137,42.2788086 39.920166,44.7263184 39.0900879,46.8625488 C38.2600098,48.9987793 37.8449707,51.8125 37.8449707,55.3037109 L37.8449707,55.3037109 L44.3635254,55.3037109 Z M44.986084,69 L44.986084,61.3828125 L37.6984863,61.3828125 L37.6984863,69 L44.986084,69 Z",
    id: "?",
    fill: "#279CF7",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.f668f57896b851e05bc3d152d077ab80.svg";
export { ForwardRef as ReactComponent };